import { EPaymentMethod, ICommunity } from "features/common/types";
import Nullable = Common.Nullable;
import { IPaymentResponse } from "@fortius/prime-ui";

export type TResolvePaymentLinkPayload = { querystring: string } | { queryString: string };

export type TPaymentLinkProduct = {
  name: string;
  amount: number;
};

export type TPaymentLinkCheckout = {
  mainProduct: TPaymentLinkProduct;
  joiningFee: Nullable<TPaymentLinkProduct>;
  marketplaceOptOut: Nullable<TPaymentLinkProduct>;
  subTotal: number;
  vat: number;
  total: number;
};

export type TPaymentLinkContent = {
  productSiloId: number;
  productSiloName: string;
  productId: number;
  productName: string;
  iconUrl: string;
  iconAlt: string;
  description: string;
};

export type TPaymentLinkBilling = {
  firstName: string;
  lastName: string;
  email: string;
  address: {
    line1: string;
    line2: string;
    town: string;
    postCode: string;
    country: string;
    county: string;
  };
};

export type TResolvePaymentLinkDto = {
  communityAccountId: number;
  activeCommunities: ICommunity[];
  invoiceId: number;
  clientSecret: string;
  paymentIntentId: string;
  amount: number;
  currency: string;
  requestReference: string;
  lang: string;
  paymentMethods: number[];
  checkout: TPaymentLinkCheckout;
  content: TPaymentLinkContent;
  billing: TPaymentLinkBilling;
};

export type TGetPaymentIntentPayload = {
  invoiceId: number;
  paymentMethod: EPaymentMethod;
  offSession?: boolean;
};

export enum EPaymentLinkApiErrorCodes {
  PaymentAlreadySucceeded = 1001,
  PaymentAlreadyInProgress = 1002,
  PaymentLinkNotFound = 1003,
  PaymentLinkExpired = 1004,
  PaymentLinkInvalidQueryString = 1005,
  CheckoutProductNotFound = 1006
}

export interface IResolvePaymentLinkResponse extends Common.IBaseApiResponse {
  result: TResolvePaymentLinkDto;
}

export interface IGetPaymentIntentResponse extends IPaymentResponse {}

export interface IResolvePaymentLinkErrorResponse extends Common.IBaseApiResponse {
  errorCode?: EPaymentLinkApiErrorCodes;
}
